import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateDevice } from 'redux/common/actions';
import FreshChat from 'react-freshchat';

import { BrowserRouter } from 'react-router-dom';
import { StripeProvider } from 'react-stripe-elements';
import { STRIPE_API_KEY } from 'shared/constants.js';

import routes from 'routes';

import MainAuthContainer from 'components/authentication/MainAuthContainer';
import CommonLoader from 'components/common/CommonLoader';
import NotFound from 'components/errors/NotFound';
import NetworkError from 'components/errors/NetworkError';

import './App.css';


class App extends Component {
  static propTypes = {
    updateDevice: PropTypes.func.isRequired,
    siteLoading: PropTypes.bool,
    notFound: PropTypes.bool,
    networkError: PropTypes.bool,
    me: PropTypes.object,
    unauthorized: PropTypes.bool,
    liveChatEnabled: PropTypes.bool,
  }

  static defaultProps = {
    siteLoading: false,
    notFound: false,
    networkError: false,
    me: null,
    unauthorized: false,
    liveChatEnabled: true,
  }

  state = {
    currentDevice: null,
    showFreshchat: false,
  };

  componentDidMount() {
    this._calculateDevice();
    window.addEventListener('resize', this._calculateDevice);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.currentDevice !== this.state.currentDevice) {
      this.props.updateDevice(this.state.currentDevice);
    }
    if (
      this.props.liveChatEnabled && (
      (!prevProps.me && this.props.me) ||
      (!prevProps.unauthorized && !this.props.me && this.props.unauthorized)
      )
    ) {
      this.setState({ showFreshchat: true });
    }
  }

  _calculateDevice = () => {
    const width = window.innerWidth;
    if (width > 1440) {
      this.setState({ currentDevice: 'desktop' });
    } else if (width < 1441 && width > 1240) {
      this.setState({ currentDevice: 'tablet_1440' });
    } else if (width < 1241 && width > 1024) {
      this.setState({ currentDevice: 'tablet_1240' });
    } else if (width < 1025 && width > 768) {
      this.setState({ currentDevice: 'tablet_1024' });
    } else if (width < 769 && width > 650) {
      this.setState({ currentDevice: 'tablet_768' });
    } else if (width <= 650) {
      this.setState({ currentDevice: 'mobile' });
    }
  };

  render() {
    const { siteLoading, notFound, networkError } = this.props;

    if (networkError) return <NetworkError />;

    let user = null;
    if (this.props.me) {
      user = {
        externalId: this.props.me.id,
        email: this.props.me.email,
        name: this.props.me.username,
        heylinkme_url: this.props.me.short_url,
        title: this.props.me.title,
      };
    }

    return (
      <BrowserRouter>
        <StripeProvider apiKey={STRIPE_API_KEY}>
          <MainAuthContainer>
            <CommonLoader active={!!siteLoading} />
            {notFound ? <NotFound /> : routes}
          </MainAuthContainer>
        </StripeProvider>

        {this.state.showFreshchat &&
          <FreshChat
            token="07dfdfa5-792a-4503-8041-da4bcebce886"
            host="https://wchat.au.freshchat.com"
            externalId={user && user.externalId}
            email={user && user.email}
            firstName={user && user.title}
            onInit={widget => {
              widget.user.setProperties({
                email: user && user.email,
                heylinkme_url: user && user.heylinkme_url,
                title: user && user.title,
              })
            }}
          />
        }

      </BrowserRouter>
    );
  }
}

const mapStateToProps = state => (
  {
    siteLoading: state.commonReducer.siteLoading,
    notFound: state.commonReducer.notFound,
    networkError: state.commonReducer.networkError,
    me: state.usersReducer.me,
    unauthorized: state.usersReducer.unauthorized,
    liveChatEnabled: state.usersReducer.liveChatEnabled,
  }
);

export default connect(
  mapStateToProps,
  {
    updateDevice,
  },
)(App);
